<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-33 md-small-size-100 tagline">
      <h2><b v-if="activated">Account activated successfully</b></h2>
      <h3>
        <b>
          {{ message }}
        </b>
      </h3>
    </div>
  </div>
</template>
<script>
import { activateAccount } from "@/api/auth.service";

export default {
  components: {},
  data() {
    return {
      message: "Your account is being activated at the moment",
      activated: null
    };
  },
  methods: {},
  beforeMount() {
    activateAccount(
      this.$route.query.encoded_pk,
      this.$route.query.activation_key
    )
      .then(_ => {
        this.activated = true;
        this.message =
          "Congratulations, your account has been activated. You can log in using your email and password.";
      })
      .catch(() => {
        this.$toasted.error("We experienced an error.", {
          position: "top-center"
        });
        this.activated = false;
        this.message =
          "We experienced an error while activating your account. Please try again later.";
      });
  }
};
</script>

<style></style>
